import { useQuery } from "@tanstack/react-query";
import type { GeoJSON } from "highcharts";

import Sentry from "@similarweb/sentry-logger";

interface IUseMapGeoJsonOptions {
    enabled?: boolean;
}

export const useMapGeoJson = (options?: IUseMapGeoJsonOptions) => {
    return useQuery<GeoJSON>({
        queryKey: ["map-geo-json"],
        queryFn: async () => {
            const response = await fetch(window["assetsRoot"] + "/images/world-lowres.json");
            if (!response.ok) {
                const error = new Error(`Failed to fetch map data: ${response.status} ${response.statusText}`);
                Sentry.error("Failed to fetch map data", error);
                throw error;
            }
            const res = (await response.json()) as GeoJSON;
            return res;
        },
        retry: false,
        staleTime: Infinity,
        gcTime: Infinity,
        enabled: options?.enabled ?? true,
    });
};
